import { render, staticRenderFns } from "./ScheduledOrders.vue?vue&type=template&id=12f0815a"
import script from "./ScheduledOrders.vue?vue&type=script&lang=ts"
export * from "./ScheduledOrders.vue?vue&type=script&lang=ts"
import style0 from "./ScheduledOrders.vue?vue&type=style&index=0&id=12f0815a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports